<template>

  <ion-page id="from-ios-page">  
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame">
        <ion-item>
        <h2>Setting Up Connection</h2>
        </ion-item>
        <ion-item v-if="hasError" color="danger">
            {{ message }}
        </ion-item>
        <ion-item v-if="!hasError">
            {{ message }}
        </ion-item>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

// https://stackoverflow.com/questions/35914069/how-can-i-get-query-parameters-from-a-url-in-vue-js

import { IonItem,IonInput,IonPage, IonContent } from '@ionic/vue';

import { ref, watch } from 'vue'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { useGetData } from '@/composables/getData.js'
import { doStartupCheck } from '@/composables/startupCheck.js'
import { availableWidthHeight } from '@/composables/screenSize'

const emit = defineEmits(['from-ios-done'])

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "light")

const menuTrigger = ref(0)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })

const urlParams =  new URLSearchParams(window.location.search)

const hasError = ref(false)
const message = ref("")
var uuid = localStorage.getItem("url_u")

if (uuid == null) {
  hasError.value = true
  message.value = "The necessary URL parameter isn't there. If this persists, please contact support@chessvis.com   In the meantime, just login into the web version directly."
}
else {
  hasError.value = false
  getUserInfo(uuid)
}

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })

 updateWidthHeights()

function afterStartupCallbackRoutine(stuffChanged) {
  updateWidthHeights()
  menuTrigger.value++

  emit('from-ios-done',"good")

}

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })
  
function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop+ availableSpace.topIndent
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"
}

function processJsonResponse (json) {
  //console.log(" in uuid callback",json)
  if (json.hasOwnProperty('error')) {
    alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
    emit('from-ios-done',"error")
    return;
  }
  switch (json['stat']) {
    case "bad link" :
      message.value = "Connection Key Error"
      emit('from-ios-done',"error")
      break
    case 'e' :
      message.value = "Connection Error"
      emit('from-ios-done',"error")
      break;
    case 'g' :
      const cookie = json['cookie']
      const email = json['email']
      const dark = json['dark']
      connectionStore.setUserCookieDummy(cookie,"0")
      connectionStore.updateEmailAddress(email)
      connectionStore.setDarkMode((dark == 1) ? "chessvis" : "light")
      message.value = "Connection Established. Login information transferred."
      doStartupCheck(true,afterStartupCallbackRoutine)
      break
  }
}

function getUserInfo(uuid) {
  message.value = "Processing web connection...."
  var formData = { 
    u : uuid, 
  }
  useGetData("process_uuid_verification.php", formData, processJsonResponse)
}



</script>

<style scoped>

</style>
